/**起飞落地 js */
import config from "@/config";
import http from "@/utils/request";

export default {
	reportPage: {
		url: `${config.MAIN_URL}/api/v1/flyPlanReport/reportPage`,
		name: "起飞落地报查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	reportSave: {
		url: `${config.MAIN_URL}/api/v1/flyPlanReport/reportSave`,
		name: "起飞落地报新增",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	airCraftSelect: {
		url: `${config.MAIN_URL}/api/v1/flyPlanReport/airCraftSelect`,
		name: "起飞落地报航空器下拉",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},

	reportDelete: {
		url: `${config.MAIN_URL}/api/v1/flyPlanReport/reportDelete`,
		name: "起飞落地报删除",
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},



};
